// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   HomeHelpingPeople — "Our belief"
   Prefix: impac_helping_pg_ · no :root variables · no green
   ============================================================ */

.impac_helping_pg_section {
  position: relative;
  width: 100%;
  padding: 72px 24px 88px;
  background: #f8f6ff;
  font-family: "Sora", "Manrope", sans-serif;
  color: #24103f;
  overflow: hidden;
}

.impac_helping_pg_section *,
.impac_helping_pg_section *::before,
.impac_helping_pg_section *::after {
  box-sizing: border-box;
}

/* ============================================================
   Outer card
   ============================================================ */

.impac_helping_pg_card {
  position: relative;
  max-width: 1000px;
  margin: 0 auto;
  padding: 52px 52px 56px;
  border: 1px solid #e4dcf9;
  border-radius: 18px;
  background: linear-gradient(135deg, #f6f1ff 0%, #f8f4ff 45%, #fff3df 100%);
  box-shadow: 0 30px 70px rgba(74, 26, 158, 0.12), 0 2px 8px rgba(74, 26, 158, 0.04);
  overflow: hidden;
  isolation: isolate;
  opacity: 0;
  transform: translateY(44px) scale(0.98);
  transition:
    opacity 0.9s ease,
    transform 1s cubic-bezier(0.22, 1, 0.36, 1);
}

.impac_helping_pg_visible .impac_helping_pg_card {
  opacity: 1;
  transform: none;
}

/* faint dot pattern */
.impac_helping_pg_dots {
  position: absolute;
  z-index: -1;
  inset: 0;
  background-image: radial-gradient(circle, rgba(74, 26, 158, 0.16) 1.2px, transparent 1.4px);
  background-size: 22px 22px;
  mask-image: linear-gradient(135deg, #000 0%, transparent 70%);
  opacity: 0.55;
  pointer-events: none;
}

/* purple glow in the top-right corner */
.impac_helping_pg_glow {
  position: absolute;
  z-index: -1;
  top: -90px;
  right: -90px;
  width: 340px;
  height: 340px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(138, 80, 230, 0.32) 0%, rgba(138, 80, 230, 0) 70%);
  pointer-events: none;
  transform: scale(0.6);
  opacity: 0;
  transition: transform 1.6s cubic-bezier(0.22, 1, 0.36, 1) 0.3s, opacity 1.2s ease 0.3s;
}

.impac_helping_pg_visible .impac_helping_pg_glow {
  transform: scale(1);
  opacity: 1;
}

.impac_helping_pg_grid {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
  align-items: center;
  column-gap: 52px;
}

/* ============================================================
   Left: copy
   ============================================================ */

.impac_helping_pg_copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
}

/* staggered fade-up used by every left-side block */
.impac_helping_pg_reveal {
  opacity: 0;
  transform: translateY(26px);
  transition:
    opacity 0.8s ease var(--d, 0ms),
    transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) var(--d, 0ms);
}

.impac_helping_pg_visible .impac_helping_pg_reveal {
  opacity: 1;
  transform: none;
}

.impac_helping_pg_visible .impac_helping_pg_card .impac_helping_pg_reveal {
  transition-delay: calc(var(--d, 0ms) + 350ms);
}

.impac_helping_pg_tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
  padding: 6px 14px;
  border: 1px solid #e4dcf9;
  border-radius: 999px;
  background: #ffffff;
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #3b003d;
}

.impac_helping_pg_tag_dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #f2a900;
}

.impac_helping_pg_title {
  margin: 0 0 22px;
  font-size: clamp(28px, 3.7vw, 44px);
  font-weight: 800;
  line-height: 1.08;
  letter-spacing: -0.025em;
}

.impac_helping_pg_title_line {
  display: block;
  color: #24103f;
}

.impac_helping_pg_title_accent {
  color: #4a1a9e;
  background: linear-gradient(90deg, #3b003d 0%, #4a1a9e 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.impac_helping_pg_text {
  max-width: 470px;
  margin: 0 0 30px;
  font-size: 15.5px;
  line-height: 1.7;
  color: #5d5978;
}

.impac_helping_pg_actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px 18px;
}

.impac_helping_pg_btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px 26px;
  border: 0;
  border-radius: 8px;
  background: #3b003d;
  box-shadow: 0 16px 30px rgba(59, 0, 61, 0.3);
  font-family: inherit;
  font-size: 14.5px;
  font-weight: 800;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  isolation: isolate;
  transition: transform 0.3s ease, box-shadow 0.3s ease, color 0.3s ease;
}

/* gold fill sweeping up on hover */
.impac_helping_pg_btn::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: #e0a83d;
  transform: translateY(101%);
  transition: transform 0.45s cubic-bezier(0.22, 1, 0.36, 1);
}

.impac_helping_pg_btn:hover {
  color: #3b003d;
  transform: translateY(-3px);
  box-shadow: 0 20px 36px rgba(224, 168, 61, 0.45);
}

.impac_helping_pg_btn:hover::before {
  transform: translateY(0);
}

.impac_helping_pg_btn:active {
  transform: translateY(0) scale(0.97);
}

.impac_helping_pg_btn:focus-visible {
  outline: 3px solid #e0a83d;
  outline-offset: 3px;
}

.impac_helping_pg_btn_arrow {
  transition: transform 0.35s ease;
}

.impac_helping_pg_btn:hover .impac_helping_pg_btn_arrow {
  transform: translateX(5px);
}

.impac_helping_pg_note {
  font-size: 12.5px;
  color: #6b6784;
}

/* ============================================================
   Right: three beliefs
   ============================================================ */

.impac_helping_pg_list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
  margin: 0;
  padding: 0;
  list-style: none;
}

.impac_helping_pg_row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  border: 1px solid #e4dcf9;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(74, 26, 158, 0.07);
  cursor: default;
  opacity: 0;
  transform: translateX(46px);
  transition:
    opacity 0.8s ease calc(var(--r, 0) * 170ms + 700ms),
    transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) calc(var(--r, 0) * 170ms + 700ms),
    box-shadow 0.3s ease,
    border-color 0.3s ease;
}

.impac_helping_pg_visible .impac_helping_pg_row {
  opacity: 1;
  transform: none;
}

/* after the entrance, hover is instant */
.impac_helping_pg_visible .impac_helping_pg_row:hover {
  transform: translateX(-8px);
  border-color: #c9b6f2;
  box-shadow: 0 16px 34px rgba(74, 26, 158, 0.16);
  transition-delay: 0s;
}

.impac_helping_pg_num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #3b003d;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.02em;
  color: #ffc94d;
  transform: scale(0.4) rotate(-20deg);
  opacity: 0;
  transition:
    transform 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) calc(var(--r, 0) * 170ms + 950ms),
    opacity 0.4s ease calc(var(--r, 0) * 170ms + 950ms);
}

.impac_helping_pg_visible .impac_helping_pg_num {
  transform: none;
  opacity: 1;
}

.impac_helping_pg_visible .impac_helping_pg_row:hover .impac_helping_pg_num {
  transform: rotate(-8deg) scale(1.1);
  transition-delay: 0s;
}

.impac_helping_pg_row_text {
  flex: 1 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.4;
  color: #24103f;
}

/* check icon draws itself */
.impac_helping_pg_check {
  flex-shrink: 0;
  color: #f2a900;
}

.impac_helping_pg_check_ring,
.impac_helping_pg_check_tick {
  stroke-dasharray: 1;
  stroke-dashoffset: 1;
  transition: stroke-dashoffset 0.8s ease calc(var(--r, 0) * 170ms + 1200ms);
}

.impac_helping_pg_check_tick {
  transition-delay: calc(var(--r, 0) * 170ms + 1500ms);
  transition-duration: 0.5s;
}

.impac_helping_pg_visible .impac_helping_pg_check_ring,
.impac_helping_pg_visible .impac_helping_pg_check_tick {
  stroke-dashoffset: 0;
}

/* ============================================================
   Responsive — 1100 / 900 / 560 / 360
   ============================================================ */

@media (max-width: 1100px) {
  .impac_helping_pg_section {
    padding: 60px 20px 76px;
  }

  .impac_helping_pg_card {
    padding: 44px 36px 48px;
  }

  .impac_helping_pg_grid {
    column-gap: 36px;
  }
}

/* stack: message on top, beliefs below */
@media (max-width: 900px) {
  .impac_helping_pg_card {
    max-width: 680px;
    padding: 40px 32px 44px;
  }

  .impac_helping_pg_grid {
    grid-template-columns: minmax(0, 1fr);
    row-gap: 36px;
  }

  .impac_helping_pg_text {
    max-width: 560px;
  }

  .impac_helping_pg_row {
    transform: translateY(30px);
  }

  .impac_helping_pg_visible .impac_helping_pg_row:hover {
    transform: translateX(-4px);
  }
}

@media (max-width: 560px) {
  .impac_helping_pg_section {
    padding: 40px 14px 56px;
  }

  .impac_helping_pg_card {
    padding: 30px 20px 32px;
    border-radius: 16px;
  }

  .impac_helping_pg_glow {
    top: -120px;
    right: -120px;
    width: 280px;
    height: 280px;
  }

  .impac_helping_pg_tag {
    margin-bottom: 16px;
  }

  .impac_helping_pg_title {
    margin-bottom: 18px;
  }

  .impac_helping_pg_text {
    margin-bottom: 24px;
    font-size: 14.5px;
  }

  .impac_helping_pg_actions {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    gap: 12px;
  }

  .impac_helping_pg_btn {
    justify-content: center;
    width: 100%;
    padding: 15px 20px;
  }

  .impac_helping_pg_note {
    text-align: center;
  }

  .impac_helping_pg_list {
    gap: 9px;
  }

  .impac_helping_pg_row {
    gap: 12px;
    padding: 14px 14px;
  }

  .impac_helping_pg_row_text {
    font-size: 14px;
  }
}

@media (max-width: 360px) {
  .impac_helping_pg_card {
    padding: 26px 16px 28px;
  }

  .impac_helping_pg_num {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }

  .impac_helping_pg_row_text {
    font-size: 13.5px;
  }
}

/* ============================================================
   Reduced motion
   ============================================================ */

@media (prefers-reduced-motion: reduce) {
  .impac_helping_pg_card,
  .impac_helping_pg_reveal,
  .impac_helping_pg_row,
  .impac_helping_pg_num,
  .impac_helping_pg_glow {
    opacity: 1 !important;
    transform: none !important;
    transition: none !important;
  }

  .impac_helping_pg_check_ring,
  .impac_helping_pg_check_tick {
    stroke-dashoffset: 0 !important;
    transition: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/HomeHelpingPeople/HomeHelpingPeople.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;iEAEiE;;AAEjE;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,0EAA0E;EAC1E,kFAAkF;EAClF,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,uCAAuC;EACvC;;+CAE6C;AAC/C;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2FAA2F;EAC3F,0BAA0B;EAE1B,6DAA6D;EAC7D,aAAa;EACb,oBAAoB;AACtB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,2FAA2F;EAC3F,oBAAoB;EACpB,qBAAqB;EACrB,UAAU;EACV,sFAAsF;AACxF;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA,oDAAoD;AACpD;EACE,UAAU;EACV,2BAA2B;EAC3B;;+DAE6D;AAC/D;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4DAA4D;EAC5D,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sEAAsE;AACxE;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,eAAe;EACf,UAAU;EACV,2BAA2B;EAC3B;;;;0BAIwB;AAC1B;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EACpC,UAAU;EACV;;uDAEqD;AACvD;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;EACpB,0EAA0E;AAC5E;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;;;;;IAKE,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;IAEE,+BAA+B;IAC/B,2BAA2B;EAC7B;AACF","sourcesContent":["/* ============================================================\n   HomeHelpingPeople — \"Our belief\"\n   Prefix: impac_helping_pg_ · no :root variables · no green\n   ============================================================ */\n\n.impac_helping_pg_section {\n  position: relative;\n  width: 100%;\n  padding: 72px 24px 88px;\n  background: #f8f6ff;\n  font-family: \"Sora\", \"Manrope\", sans-serif;\n  color: #24103f;\n  overflow: hidden;\n}\n\n.impac_helping_pg_section *,\n.impac_helping_pg_section *::before,\n.impac_helping_pg_section *::after {\n  box-sizing: border-box;\n}\n\n/* ============================================================\n   Outer card\n   ============================================================ */\n\n.impac_helping_pg_card {\n  position: relative;\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 52px 52px 56px;\n  border: 1px solid #e4dcf9;\n  border-radius: 18px;\n  background: linear-gradient(135deg, #f6f1ff 0%, #f8f4ff 45%, #fff3df 100%);\n  box-shadow: 0 30px 70px rgba(74, 26, 158, 0.12), 0 2px 8px rgba(74, 26, 158, 0.04);\n  overflow: hidden;\n  isolation: isolate;\n  opacity: 0;\n  transform: translateY(44px) scale(0.98);\n  transition:\n    opacity 0.9s ease,\n    transform 1s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.impac_helping_pg_visible .impac_helping_pg_card {\n  opacity: 1;\n  transform: none;\n}\n\n/* faint dot pattern */\n.impac_helping_pg_dots {\n  position: absolute;\n  z-index: -1;\n  inset: 0;\n  background-image: radial-gradient(circle, rgba(74, 26, 158, 0.16) 1.2px, transparent 1.4px);\n  background-size: 22px 22px;\n  -webkit-mask-image: linear-gradient(135deg, #000 0%, transparent 70%);\n  mask-image: linear-gradient(135deg, #000 0%, transparent 70%);\n  opacity: 0.55;\n  pointer-events: none;\n}\n\n/* purple glow in the top-right corner */\n.impac_helping_pg_glow {\n  position: absolute;\n  z-index: -1;\n  top: -90px;\n  right: -90px;\n  width: 340px;\n  height: 340px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(138, 80, 230, 0.32) 0%, rgba(138, 80, 230, 0) 70%);\n  pointer-events: none;\n  transform: scale(0.6);\n  opacity: 0;\n  transition: transform 1.6s cubic-bezier(0.22, 1, 0.36, 1) 0.3s, opacity 1.2s ease 0.3s;\n}\n\n.impac_helping_pg_visible .impac_helping_pg_glow {\n  transform: scale(1);\n  opacity: 1;\n}\n\n.impac_helping_pg_grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);\n  align-items: center;\n  column-gap: 52px;\n}\n\n/* ============================================================\n   Left: copy\n   ============================================================ */\n\n.impac_helping_pg_copy {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-width: 0;\n}\n\n/* staggered fade-up used by every left-side block */\n.impac_helping_pg_reveal {\n  opacity: 0;\n  transform: translateY(26px);\n  transition:\n    opacity 0.8s ease var(--d, 0ms),\n    transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) var(--d, 0ms);\n}\n\n.impac_helping_pg_visible .impac_helping_pg_reveal {\n  opacity: 1;\n  transform: none;\n}\n\n.impac_helping_pg_visible .impac_helping_pg_card .impac_helping_pg_reveal {\n  transition-delay: calc(var(--d, 0ms) + 350ms);\n}\n\n.impac_helping_pg_tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 18px;\n  padding: 6px 14px;\n  border: 1px solid #e4dcf9;\n  border-radius: 999px;\n  background: #ffffff;\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #3b003d;\n}\n\n.impac_helping_pg_tag_dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #f2a900;\n}\n\n.impac_helping_pg_title {\n  margin: 0 0 22px;\n  font-size: clamp(28px, 3.7vw, 44px);\n  font-weight: 800;\n  line-height: 1.08;\n  letter-spacing: -0.025em;\n}\n\n.impac_helping_pg_title_line {\n  display: block;\n  color: #24103f;\n}\n\n.impac_helping_pg_title_accent {\n  color: #4a1a9e;\n  background: linear-gradient(90deg, #3b003d 0%, #4a1a9e 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.impac_helping_pg_text {\n  max-width: 470px;\n  margin: 0 0 30px;\n  font-size: 15.5px;\n  line-height: 1.7;\n  color: #5d5978;\n}\n\n.impac_helping_pg_actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 14px 18px;\n}\n\n.impac_helping_pg_btn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 15px 26px;\n  border: 0;\n  border-radius: 8px;\n  background: #3b003d;\n  box-shadow: 0 16px 30px rgba(59, 0, 61, 0.3);\n  font-family: inherit;\n  font-size: 14.5px;\n  font-weight: 800;\n  color: #ffffff;\n  cursor: pointer;\n  overflow: hidden;\n  isolation: isolate;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, color 0.3s ease;\n}\n\n/* gold fill sweeping up on hover */\n.impac_helping_pg_btn::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background: #e0a83d;\n  transform: translateY(101%);\n  transition: transform 0.45s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.impac_helping_pg_btn:hover {\n  color: #3b003d;\n  transform: translateY(-3px);\n  box-shadow: 0 20px 36px rgba(224, 168, 61, 0.45);\n}\n\n.impac_helping_pg_btn:hover::before {\n  transform: translateY(0);\n}\n\n.impac_helping_pg_btn:active {\n  transform: translateY(0) scale(0.97);\n}\n\n.impac_helping_pg_btn:focus-visible {\n  outline: 3px solid #e0a83d;\n  outline-offset: 3px;\n}\n\n.impac_helping_pg_btn_arrow {\n  transition: transform 0.35s ease;\n}\n\n.impac_helping_pg_btn:hover .impac_helping_pg_btn_arrow {\n  transform: translateX(5px);\n}\n\n.impac_helping_pg_note {\n  font-size: 12.5px;\n  color: #6b6784;\n}\n\n/* ============================================================\n   Right: three beliefs\n   ============================================================ */\n\n.impac_helping_pg_list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.impac_helping_pg_row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px 18px;\n  border: 1px solid #e4dcf9;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 8px 22px rgba(74, 26, 158, 0.07);\n  cursor: default;\n  opacity: 0;\n  transform: translateX(46px);\n  transition:\n    opacity 0.8s ease calc(var(--r, 0) * 170ms + 700ms),\n    transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) calc(var(--r, 0) * 170ms + 700ms),\n    box-shadow 0.3s ease,\n    border-color 0.3s ease;\n}\n\n.impac_helping_pg_visible .impac_helping_pg_row {\n  opacity: 1;\n  transform: none;\n}\n\n/* after the entrance, hover is instant */\n.impac_helping_pg_visible .impac_helping_pg_row:hover {\n  transform: translateX(-8px);\n  border-color: #c9b6f2;\n  box-shadow: 0 16px 34px rgba(74, 26, 158, 0.16);\n  transition-delay: 0s;\n}\n\n.impac_helping_pg_num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  background: #3b003d;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  color: #ffc94d;\n  transform: scale(0.4) rotate(-20deg);\n  opacity: 0;\n  transition:\n    transform 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) calc(var(--r, 0) * 170ms + 950ms),\n    opacity 0.4s ease calc(var(--r, 0) * 170ms + 950ms);\n}\n\n.impac_helping_pg_visible .impac_helping_pg_num {\n  transform: none;\n  opacity: 1;\n}\n\n.impac_helping_pg_visible .impac_helping_pg_row:hover .impac_helping_pg_num {\n  transform: rotate(-8deg) scale(1.1);\n  transition-delay: 0s;\n}\n\n.impac_helping_pg_row_text {\n  flex: 1;\n  min-width: 0;\n  font-size: 15px;\n  font-weight: 800;\n  line-height: 1.4;\n  color: #24103f;\n}\n\n/* check icon draws itself */\n.impac_helping_pg_check {\n  flex-shrink: 0;\n  color: #f2a900;\n}\n\n.impac_helping_pg_check_ring,\n.impac_helping_pg_check_tick {\n  stroke-dasharray: 1;\n  stroke-dashoffset: 1;\n  transition: stroke-dashoffset 0.8s ease calc(var(--r, 0) * 170ms + 1200ms);\n}\n\n.impac_helping_pg_check_tick {\n  transition-delay: calc(var(--r, 0) * 170ms + 1500ms);\n  transition-duration: 0.5s;\n}\n\n.impac_helping_pg_visible .impac_helping_pg_check_ring,\n.impac_helping_pg_visible .impac_helping_pg_check_tick {\n  stroke-dashoffset: 0;\n}\n\n/* ============================================================\n   Responsive — 1100 / 900 / 560 / 360\n   ============================================================ */\n\n@media (max-width: 1100px) {\n  .impac_helping_pg_section {\n    padding: 60px 20px 76px;\n  }\n\n  .impac_helping_pg_card {\n    padding: 44px 36px 48px;\n  }\n\n  .impac_helping_pg_grid {\n    column-gap: 36px;\n  }\n}\n\n/* stack: message on top, beliefs below */\n@media (max-width: 900px) {\n  .impac_helping_pg_card {\n    max-width: 680px;\n    padding: 40px 32px 44px;\n  }\n\n  .impac_helping_pg_grid {\n    grid-template-columns: minmax(0, 1fr);\n    row-gap: 36px;\n  }\n\n  .impac_helping_pg_text {\n    max-width: 560px;\n  }\n\n  .impac_helping_pg_row {\n    transform: translateY(30px);\n  }\n\n  .impac_helping_pg_visible .impac_helping_pg_row:hover {\n    transform: translateX(-4px);\n  }\n}\n\n@media (max-width: 560px) {\n  .impac_helping_pg_section {\n    padding: 40px 14px 56px;\n  }\n\n  .impac_helping_pg_card {\n    padding: 30px 20px 32px;\n    border-radius: 16px;\n  }\n\n  .impac_helping_pg_glow {\n    top: -120px;\n    right: -120px;\n    width: 280px;\n    height: 280px;\n  }\n\n  .impac_helping_pg_tag {\n    margin-bottom: 16px;\n  }\n\n  .impac_helping_pg_title {\n    margin-bottom: 18px;\n  }\n\n  .impac_helping_pg_text {\n    margin-bottom: 24px;\n    font-size: 14.5px;\n  }\n\n  .impac_helping_pg_actions {\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n    gap: 12px;\n  }\n\n  .impac_helping_pg_btn {\n    justify-content: center;\n    width: 100%;\n    padding: 15px 20px;\n  }\n\n  .impac_helping_pg_note {\n    text-align: center;\n  }\n\n  .impac_helping_pg_list {\n    gap: 9px;\n  }\n\n  .impac_helping_pg_row {\n    gap: 12px;\n    padding: 14px 14px;\n  }\n\n  .impac_helping_pg_row_text {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 360px) {\n  .impac_helping_pg_card {\n    padding: 26px 16px 28px;\n  }\n\n  .impac_helping_pg_num {\n    width: 32px;\n    height: 32px;\n    font-size: 12px;\n  }\n\n  .impac_helping_pg_row_text {\n    font-size: 13.5px;\n  }\n}\n\n/* ============================================================\n   Reduced motion\n   ============================================================ */\n\n@media (prefers-reduced-motion: reduce) {\n  .impac_helping_pg_card,\n  .impac_helping_pg_reveal,\n  .impac_helping_pg_row,\n  .impac_helping_pg_num,\n  .impac_helping_pg_glow {\n    opacity: 1 !important;\n    transform: none !important;\n    transition: none !important;\n  }\n\n  .impac_helping_pg_check_ring,\n  .impac_helping_pg_check_tick {\n    stroke-dashoffset: 0 !important;\n    transition: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
